//#region src/generated/locales/en.ts
var templates = {
	"pd.contactus.address.email": `Email`,
	"pd.contactus.address.message": `Message`,
	"pd.contactus.address.name": `Name`,
	"pd.contactus.address.phone": `Phone`,
	"pd.contactus.address.send": `Send`,
	"pd.login.email.label": `Email`,
	"pd.login.forgot.back": `Back to Login`,
	"pd.login.forgot.info": `Enter your email address. You will receive a link to reset your password.`,
	"pd.login.forgot.password": `Forgot password?`,
	"pd.login.forgot.submit": `Request Link`,
	"pd.login.password.label": `Password`,
	"pd.login.submit": `Sign in`,
	"pdPage.toast.ariaClose": `Close`,
	"pd.footer.nav.aria": `Footer Navigation`,
	"pd.footer.social.aria": `Social Media`,
	"pd.footer.legal.aria": `Legal Navigation`,
	"pd.menu.nav.aria": `Hauptnavigation`,
	"pd.menu.locale.aria": `Sprache auswählen`,
	"pd.menu.burger.aria": `Menü öffnen`
};
//#endregion
export { templates };
